import React from 'react';
import PropTypes from 'prop-types';
import Step from './Step';

import DownloadAction from './TalentAssessmentStep/Download';
import DisableAction from './TalentAssessmentStep/Disable';

export default function TalentAssessmentStep({ step, showStep, setShowStep }) {
  const isStartAction = step.actions.find(
    (item) => item.action === 'start_cpa',
  );
  const isDownloadAction = step.actions.find(
    (item) => item.action === 'download',
  );

  return (
    <Step
      step={step}
      iconClassName="career-pulse-assessment-icon bg-white"
      iconBg="bg-tertiary-1000"
      showStep={showStep}
      setShowStep={setShowStep}
    >
      <>
        {step.actions.length === 0 && <DisableAction />}
        {isStartAction && <DisableAction />}
        {isDownloadAction && <DownloadAction step={step} />}
      </>
    </Step>
  );
}

TalentAssessmentStep.propTypes = {
  step: PropTypes.object.isRequired,
  showStep: PropTypes.bool.isRequired,
  setShowStep: PropTypes.func.isRequired,
};
